module.exports = __webpack_public_path__ + "b46556e42b5acc14c33c9f8637917632.png";